export const RESET = 'FULFILLMENT_LIST_RESET'
export const SET_VIEW = 'FULFILLMENT_LIST_SET_VIEW'
export const SET_ITEMS = 'FULFILLMENT_LIST_SET_ITEMS'
export const TOGGLE_LOADING = 'FULFILLMENT_LIST_TOGGLE_LOADING'
